<template>
  <div>
    <alert-message-modal></alert-message-modal>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-12 col-xl-12 profile-header">
          <div class="grow-3 text-center bg-primary">
            <img class="img-avatar img-avatar48 img-avatar-thumb" src="static/media/avatars/avatar10.jpg" alt="profile">
<!--            <div class="block-header bg-primary">
              <button type="button" class="btn-block-option text-white text-right" @click="save" title="Click to save changes">
              <i class="fa fa-save mr-1"></i>Save
              </button>
            </div>-->
          </div>
          <div class="block-content block-content-full">
            <div class="row">
              <div class="form-group col-12 col-md-6 col-xl-6 required">
                <label class="control-label">First Name</label>
                <input type="text" class="form-control form-control-alt" id="first_name" placeholder="Enter first name" v-model="user.firstName" name="firstName" v-validate="'required'" data-vv-as="First Name" @keyup="user.firstNameErr = ''">
                <p v-if="errors.has('firstName')" class="error">{{ errors.first('firstName') }}</p>
                <p v-if="user.firstNameErr" class="error">{{ user.firstNameErr }}</p>
              </div>
              <div class="form-group col-12 col-md-6 col-xl-6 required">
                <label class="control-label">Last Name</label>
                <input type="text" class="form-control form-control-alt" id="last_name" placeholder="Enter last name" v-model="user.lastName" name="lastName" v-validate="'required'" data-vv-as="Last Name" @keyup="user.lastNameErr = ''">
                <p v-if="errors.has('lastName')" class="error">{{ errors.first('lastName') }}</p>
                <p v-if="user.lastNameErr" class="error">{{ user.lastNameErr }}</p>
              </div>
              <div class="form-group col-12 col-md-6 col-xl-6 required">
                <label class="control-label">E-mail</label>
                <div v-bind:class="[ showVerifyButton ? 'check'  : 'uncheck' ]">
                  <input type="text" class="form-control form-control-alt" id="profile-email" v-model="user.email" name="email" placeholder="Enter email" v-validate="'required|verify_email'" data-vv-as="Email" @keyup="user.emailErr = ''" autocomplete="on">
                  <button v-if="showVerifyButton" class="btn btn-success" @click="verifyEmail" title="Your email is not yet verified. Please click here to verfiy your email.">verify</button>
                </div>
                <p v-if="errors.has('email')" class="errorMsg">{{ errors.first('email') }}</p>
                <p v-if="user.emailErr" class="error">{{user.emailErr}}</p>
              </div>
              <div class="form-group col-12 col-md-6 col-xl-6">
                <label>Mobile Number</label>
                <input v-mask="'(###) ###-####'" type="text" class="form-control form-control-alt" id="mobile_number" placeholder="Enter mobile number" v-model="user.mobileNumber" name="mobile" data-vv-as="Mobile Number">
              </div>
            </div>
          </div>
          <div>
            <div class="block-header bg-primary">
              <h3 class="block-title text-white">Facilities</h3>
              <button href="#" type="button" class="btn-block-option text-white" title="Click to add new fecility" style="padding-right:20px;" @click="addFacility()" v-scroll-to="{ element:'#scrollTodown', duration: 3000 }">
              <i class="fa fa-fw fa-plus mr-1 text-white"></i>Add
              </button>
            </div>
            <div v-for="(item, index) in facility" :key="index" v-bind:class="[ index == 0  ? 'add-facility block-content'  : 'remove-facility remove-block-content' ]" class="block-content block-content-full">
              <div class="row block-content block-content-full border-facility block-content">
                <div v-if="index > 0" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-end">
                  <button href="#" title="Click to delete fecility details" @click="deleteFacility(index)" class="clone btn delete-icon"><i class="fa fa-trash-alt"></i></button>
                </div>
                <div class="form-group col-12 col-md-6 col-xl-6 required">
                  <label class="control-label">Business Name</label>
                  <input type="text" class="form-control form-control-alt" v-model="item.businessName" :name="item.errBusinessName" v-validate="'required'" data-vv-as="Business Name" @keyup="item.businessNameErr = ''" placeholder="Enter business name">
                  <p v-if="'errors.has(' + item.errBusinessName + ')'" class="error">{{ errors.first(item.errBusinessName) }}</p>
                  <p v-if="item.businessNameErr" class="error">{{ item.businessNameErr }}</p>
                </div>
                <div class="form-group col-12 col-md-6 col-xl-6" id="autoComplete">
                  <label>Address</label>
                  <auto-complete :map="item.autoComplete" :indexValue="index" @autofill-address="setPlaces"></auto-complete>
                </div>
                <div class="form-group col-12 col-md-6 col-xl-6 required">
                  <label class="control-label">Metrc API Key</label>
                  <input type="text" class="form-control form-control-alt" v-model="item.metrcUserApiKey" :name="item.errApiKey" v-validate="'required'" data-vv-as="Metrc User Api Key" @keyup="item.metrcUserApiKeyErr = ''" placeholder="Enter metrc API key">
                  <p v-if="'errors.has(' + item.errApiKey + ')'" class="error">{{ errors.first(item.errApiKey) }}</p>
                  <p v-if="item.metrcUserApiKeyErr" class="error">{{ item.metrcUserApiKeyErr }}</p>
                </div>
                <div class="form-group col-12 col-md-6 col-xl-6 required">
                  <label class="control-label">License Number</label>
                  <input type="text" class="form-control form-control-alt" v-model="item.licenseNumber" :name="item.errLicenseNumber"  v-validate="{ required: true, regex: /^[a-zA-Z0-9-]+$/ }" data-vv-as="License Number" @keyup="item.licenseNumberErr = ''" placeholder="Enter license number">
                  <p v-if="'errors.has(' + item.errLicenseNumber + ')'" class="error">{{ errors.first(item.errLicenseNumber) }}</p>
                  <p v-if="item.licenseNumberErr" class="error">{{ item.licenseNumberErr }}</p>
                </div>
              </div>
            </div>
            <div id="scrollTodown" class="block-content block-content-full text-right border-top button-loader">
              <button type="button" class="btn btn-sm btn-light" @click="$router.go(-1)">Back</button>
              <button type="button" class="btn btn-sm btn-primary" @click="save" title="Click to save changes" :bind:disabled="showButtonLoader">
                <div><i class="fa fa-save mr-1"></i><span>Save</span></div>
                <span class="modal-loader" v-if="showButtonLoader">
                  <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { mapActions } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import VueMask from 'v-mask';
import AutoComplete from  '@/components/google-input/GoogleAutoSearch';
import AlertMessageModal from '@/components/AlertMessageModal';
import { helper } from '@/helper.js';
import VueScrollTo from 'vue-scrollto';
import base64 from 'base-64';
import utf8 from 'utf8';
Vue.use(base64, utf8, VueScrollTo, VueMask, VeeValidate, VueSpinners);

VeeValidate.Validator.extend('verify_email', {
  getMessage: field => 'Please enter a valid email.',
  validate: value => {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\0s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
  }
});

export default {
  name: 'Profile',
  data: () => ({
    user: {
      id: 0,
      firstName: '',
      lastName: '',
      email: '',
      mobileNumber: '',
      emailErr: '',
      firstNameErr: '',
      lastNameErr: '',
      passwordErr: ''
    },
    facility: [],
    counter: 0,
    showVerifyButton: false,
    showButtonLoader: false
  }),
  components: {
    AutoComplete,
    AlertMessageModal,
    HashLoader
  },
  created: function () {
    this.getAndParseUserDetails();
  },
  mounted() {
    let vm = this;
    setTimeout(
      function(){
        vm.updateFacilityAddress();
      },
      500
    );
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    ...mapActions('library', ['clearData']),
    getAndParseUserDetails() {
      let vm = this;
      let email = utf8.decode(base64.decode(localStorage.token));
      helper.sendPostRequest('/user/get', {'email': email})
        .then((data) => {
          if (data.status === 'success') {
            vm.user.id = data.data.user.id;
            vm.user.firstName = data.data.user.firstName;
            vm.user.lastName  = data.data.user.lastName;
            vm.user.email = data.data.user.email;
            vm.showVerifyButton = data.data.user.verified == 1 ? false : true;
            vm.user.mobileNumber = data.data.user.mobileNumber;
            vm.facility = data.data.facility;
            vm.addExtraParamsToFacility();
            vm.counter = Object.keys(vm.facility).length;
          }
        }).catch(function() {
          vm.error('Unable to process your request, Please try again later.');
          this.triggerMessageModal('#alert_modal');
        });
    },
    save() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (valid) {
          vm.showButtonLoader = true;
          helper.sendPostRequest('/user/update', {
            'user': {
              'id'  : vm.user.id,
              'email': vm.user.email,
              'firstName': vm.user.firstName,
              'lastName': vm.user.lastName,
              'mobileNumber': vm.user.mobileNumber
            },
            'facility' : vm.facility,
            'submit' : 1
          }).then((data) => {
            if (data && data.status === 'error') {
              if (typeof data.data.user !== 'undefined') {
                if (data.data.user.hasOwnProperty('firstName')) {
                  vm.user.firstNameErr = data.data.user.firstName;
                }
                if (data.data.user.hasOwnProperty('lastName')) {
                  vm.user.lastNameErr = data.data.user.lastName;
                }
                if (data.data.user.hasOwnProperty('email')) {
                  vm.user.emailErr = data.data.user.email;
                }
              }
              if (typeof data.data.facility !== 'undefined') {
                for (var i in data.data.facility) {
                  let v = data.data.facility[i];
                  if (v.hasOwnProperty('businessName')) {
                    vm.facility[i].businessNameErr = v.businessName;
                  }
                  if (v.hasOwnProperty('metrcUserApiKey')) {
                    vm.facility[i].metrcUserApiKeyErr = v.metrcUserApiKey;
                  }
                  if (v.hasOwnProperty('licenseNumber')) {
                    vm.facility[i].licenseNumberErr = v.licenseNumber;
                  }
                }
              }
            }
            if (data && data.status === 'success') {
              vm.success(data.message);
              this.triggerMessageModal('#alert_modal');
            }

            if (data.action && data.action === 'logout') {
              setTimeout(function(){helper.finishLogout();},5200);
            }

            if (data.action && data.action === 'clear') {
              vm.clearData();
              helper.loadSiteData();
            }
            vm.showButtonLoader = false;
          }).catch(function(error) {
            vm.error('Unable to process your request.');
            this.triggerMessageModal('#alert_modal');
            vm.showButtonLoader = false;
          });
        }
      });
    },
    addFacility() {
      this.counter++;
      this.facility.push({
        id: 0,
        businessName: '',
        address: '',
        metrcUserApiKey: '',
        licenseNumber: '',
        businessNameErr: '',
        licenseNumberErr: '',
        metrcUserApiKeyErr: '',
        errBusinessName: `businessName_${this.counter}`,
        autoComplete: `address_${this.counter}`,
        errApiKey: `apiKey_${this.counter}`,
        errLicenseNumber: `licenseNumber_${this.counter}`,
        isDefault: 0
      });
    },
    deleteFacility(index) {
      this.facility.splice(index, 1);
      let vm = this;
      setTimeout(
        function(){
          vm.updateFacilityAddress();
        },
        0
      );
    },
    setPlaces(val) {
      this.facility[val.index].address = this.$el.querySelector('#' + this.facility[val.index].autoComplete).value;
    },
    verifyEmail() {
      let vm = this;
      helper.sendPostRequest('/user/verify', {'id': vm.user.id })
        .then((data) => {
          if (data.status === 'success') {
            vm.success(data.message);
            vm.showVerifyButton = true;
          } else {
            vm.error(data.message);
          }
          this.triggerMessageModal('#alert_modal');
        }).catch(function() {
          vm.error('Unable to process your request, Please try again later.');
          this.triggerMessageModal('#alert_modal');
        });
    },
    addExtraParamsToFacility() {
      this.facility.forEach(function(facility, index){
        facility.businessNameErr = '';
        facility.licenseNumberErr = '';
        facility.metrcUserApiKeyErr = '';
        facility.errBusinessName = `businessName_${index}`;
        facility.autoComplete = `address_${index}`;
        facility.errApiKey = `apiKey_${index}`;
        facility.errLicenseNumber = `licenseNumber_${index}`;
      });
    },
    updateFacilityAddress() {
      this.facility.forEach(function(facility, key){
        jQuery('#' + facility.autoComplete).val(facility.address);
      });
    }
  }
};
</script>

<style scoped>
.grow-3 {
  padding: 1.5rem !important;
}
.img-avatar.img-avatar48 {
  width: 70px;
  height: 70px;
}
.grow-3 .block-header {
  padding: 0.375rem 1.25rem;
}
.profile-header {
  padding-bottom: 2rem;
  padding-top: 2rem;
}
.delete-icon,
.delete-icon:hover {
  color: red;
}
.error {
  font-size: 0.7rem;
  line-height: 16px;
  padding-top: 5px;
  margin-bottom: 0 !important;
}
.clone.btn:focus {
  box-shadow: none;
}
.profile-header ::placeholder,
.profile-header :-ms-input-placeholder,
.profile-header ::-ms-input-placeholder {
  color: #575757;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
}
#autoComplete .form-control-lg {
  height: calc(2.25rem + 2px);
  font-size: 1rem;
}
.profile-header .block-header {
  justify-content: flex-end;
}
 .check {
  position: relative;
}
.check input {
  width: calc(100% - 70px);
}
.check button {
  position: absolute;
  top: 0;
  right: 0;
  width: 70px;
  display: block;
}
.uncheck button {
  display: none;
}
.remove-facility .block-content {
  padding: 0 7px;
}
.add-facility .block-content {
  padding: 20px 7px 0;
}
.profile-header {
  background: #fff;
  padding: 0;
  margin-bottom: 2rem;
}
#scrollTodown.block-content.block-content-full {
    margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// source/components/Profile.vue